module.exports = __webpack_public_path__ + "media/images/lp/1/donation2-title-pc-1874f88018d61233b1bf5bc9749f73eb.png";